module.exports = __webpack_public_path__ + "img/img_area.a612090c.png";